import './App.scss';

import { Component } from 'react';
import AppNavigation from './CoreComponents/AppNavigation';
import AppHeader from './CoreComponents/AppHeader';
import { Outlet } from 'react-router';
import { AlertList } from './CoreComponents/AlertList';
import ApplicationState from './mobx/ApplicationState';
import { observe } from 'mobx';
import { Auth0Provider } from "@auth0/auth0-react";
import SharedData from "./config/SharedData.json";
import { Alert, Container } from 'react-bootstrap';


class App extends Component {
  applicationStateCleanup = null;

  constructor(props) {
    super(props);

    this.state = {
      currentNotification: null
    };
  }

  async componentDidMount() {
    this.applicationStateCleanup = observe(ApplicationState, () => {
      this.forceUpdate()
    });

    const data = await fetch(`${process.env.PUBLIC_URL}/current-notification.json`)
    this.setState({currentNotification: await data.json()});
  }
  componentWillUnmount() {
    if (this.applicationStateCleanup) {
      this.applicationStateCleanup();
    }
  }

  closeCurrentAlert() {
    window.localStorage.setItem("RetroPuzzleMakerV2.LastDismissedAlert", this.state.currentNotification.id);
    this.forceUpdate();
  }

  render() {
    const styleTag = {};
    if (ApplicationState.emulatorIsVisible) {
      styleTag.display = 'none';
    }

    // No layout on non-app pages
    if (window.location.pathname.startsWith('/play/')) {
      return (
        <div className="App no-border play">
          <AppHeader className="app-header" />
          <main className="app-body app-no-border">
            <Outlet />
          </main>
        </div>
      )
    }

    let alert = [];

    if (this.state.currentNotification && !this.state.currentNotification.dismissed && parseInt(window.localStorage.getItem("RetroPuzzleMakerV2.LastDismissedAlert") || 0, 10) < this.state.currentNotification.id) {
      alert = (<Container><Alert 
        variant={this.state.currentNotification.level}
        onClose={() => this.closeCurrentAlert()}
        dismissible
        >
          <Alert.Heading>{this.state.currentNotification.title}</Alert.Heading>
          <p className="mt-3" dangerouslySetInnerHTML={{__html: this.state.currentNotification.message}} />
        </Alert></Container>)

    }

    return (
      <Auth0Provider
        domain="cpprograms.auth0.com"
        clientId="WSUwQt7Hg4EpfdaXesvOwTWa4Au4olrx"
        redirectUri={window.location.origin}
        scope="modify:game"
      >
  
        <div className={"App"+ (ApplicationState.navIsOpen ? ' nav-open' : '') + (window.isSoloApp ? ' solo-app' : '')}>

          <AppHeader className="app-header" />
          <AppNavigation className={"app-nav"} />
          <AlertList />
          <main className="app-body" style={styleTag}>
            {alert}
            <Outlet />
            <footer>
              <small>
                Copyright 2023 <a href="https://indiegameweb.com">IndieGameWeb, LLC</a> 
                {' '}
                <small>(v {SharedData.appVersion})</small>
              </small>
            </footer>
          </main>
        </div>
      </Auth0Provider>
    );
  }
}

export default App;
